var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:[{ 'no--dot': !_vm.hasDot }]},[(_vm.hasDot)?_c('span',{staticClass:"status-dot",class:['status-dot--' + _vm.type]}):_vm._e(),_c('span',{staticClass:"status-text",class:['status-text--' + _vm.type]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }